// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M11.95 8C11.95 10.18 10.18 11.95 8 11.95C5.82 11.95 4.05 10.18 4.05 8C4.05 5.82 5.82 4.05 8 4.05C10.18 4.05 11.95 5.82 11.95 8Z',
  'M9.4 8C9.4 8.77 8.77 9.4 8 9.4C7.23 9.4 6.6 8.77 6.6 8C6.6 7.23 7.23 6.6 8 6.6C8.77 6.6 9.4 7.23 9.4 8Z',
];
